import hcmusLogo from "../../public/hcmus2.png";
import Circle from "../LogoSVG/Circle";

export const HcmusMobile = () => {
  return (
    <div className="">
      <div className="w-[200px] 2xl:h-14 2xl:w-14 overflow-hidden bg-white rounded p-2 mb-4">
        <img
          src={hcmusLogo}
          alt="logo"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="flex flex-col justify-start">
        <p className="mb-1 font-medium text-[18px]">
          University of Science - Vietnam National University | Vietnam
        </p>
        <div className="flex flex-row mt-2 mb-2">
          <p className="text-gray-4">
             Bachelor of Science - BS, Computer Science | 2020 - 2024
          </p>
        </div>

        <div className="flex flex-row items-start mb-2">
          <div className="text-gray-4">
            Supervisor:&nbsp;
            <a
              className="text-custom-green"
              href="https://www.fit.hcmus.edu.vn/~dbtien/"
              target="_blank"
            >
              Prof. Tien Ba Dinh
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
